var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMoneyOff = function SvgMoneyOff(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.7 8A3 3 0 0 0 14 6h-4m6.121 11.121A3 3 0 0 1 14 18h-4a3 3 0 0 1-2.7-2m.102-8.5A3 3 0 0 0 10 12h2m4.121 0a2.998 2.998 0 0 1 1.391 1.561M12 18v3m0-18v3-3ZM3 3l18 18",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
export default SvgMoneyOff;